const ConfiguracoesMain = () => import(/* webpackChunkName: "group-pabx-config" */ '../views/ConfiguracoesMain')

import firewallRoutes from '../modules/firewall/_routes'
import mainConfigRoutes from '../modules/geral/_routes'
import facilidadesRoutes from '../modules/facilidades/_routes'
import webHooksRoutes from '../modules/webhooks/_routes'
import transportRoutes from '../modules/transport/_routes'
import sipConfigRoutes from '../modules/sip/_routes'


import { permissionsPabx } from '../../../utils/permissionsPabx'

export default [
  {
    path: 'configuracoes',
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    component: ConfiguracoesMain,
    children: [
      ...firewallRoutes, 
      ...mainConfigRoutes, 
      ...facilidadesRoutes, 
      ...webHooksRoutes, 
      ...transportRoutes,
      ...sipConfigRoutes,
    ],
  },
]
